import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { checkDynamicContent, checkIfFieldDisabled, deepCopy, makeid } from 'na-lib';
import { validColorValidator } from 'src/app/validators/color.validator';
import { urlInvalidCharactersValidator } from '../../../validators/formValidators.dt';

@Component({
    selector: 'app-annotatedmap-annotation-dynamic-dialog',
    templateUrl: './annotatedmap-annotation-dynamic-dialog.component.html',
    styleUrl: './annotatedmap-annotation-dynamic-dialog.component.css',
    standalone: false
})

export class AnnotatedmapAnnotationDynamicDialogComponent {
  annotationColumns:any
  actualPolygonOptions:any
  annotationData:any
  newAnnotationForm!:FormGroup
  propertiesForm!:FormGroup
  passId:any
  widgetNumber:any
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|#\S+|child:[^\s]+|dpp:\/\/main|(?:https?:\/\/|context:\/\/|pass:\/\/|content:\/\/|task:\/\/|tridy:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;
  urlRegexDynamic = /^\$\{[A-Za-z0-9._:-]+\}$/;

  annotatedMapEditData:any
  annotationId:any
  BADGE:any

  invalid_pinBackgroundColor = false
  invalid_pinForegroundColor = false
  invalid_lineColor = false
  invalid_fillColor = false
  invalid_strokeColor = false
  colorPalette:any  =[]

  lat:any
  lng:any
  coordinate:any
  type:any

  constructor(public dialogRef: MatDialogRef<AnnotatedmapAnnotationDynamicDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder){
    dialogRef.disableClose = true;
  }

  ngOnInit(): void{
    if(this.data.encodedContent)
    this.actualPolygonOptions = this.data.encodedContent

    this.annotationId = this.data.id
    this.passId = this.data.passId
    this.widgetNumber= this.data.widgetNumber
    this.BADGE = this.data.index
    this.annotatedMapEditData = this.data.mapData

    this.initializePaletteColors()
    this.initAnnotationForm(this.data.values, this.data.fields)
    this.checkInvalidColors()

  }

  initAnnotationForm(data, fields){
    let defBackColor = undefined, defForeColor = undefined
    let {dynamic, source, properties, id } = data

    const {name, lat, lng, badge, coordinate, subtitle, title ,linkURL, encodedContent,directions } = properties
    this.lat = deepCopy(lat)
    this.lng = deepCopy(lng)
    this.coordinate = deepCopy(coordinate)

    let {strokeColor,fillColor, lineCap, lineWidth, type, pinColor, lineColor , pinForegroundColor, pinBackgroundColor } = data
    let disableFields = this.data.translate ? ( this.data.translateOriginal ? this.data.translateOriginal : true) : true

    this.type = deepCopy( type )

    if(type == "point"){
      defBackColor = '#FF5E38'
      defForeColor = '#000000'
    }
    this.setFieldVaildator('linkURL', linkURL)

    if(this.actualPolygonOptions){
      if(!strokeColor)
      strokeColor = this.actualPolygonOptions.strokeColor

      if(!fillColor)
      fillColor = this.actualPolygonOptions.fillColor

      if(!lineWidth)
      lineWidth = this.actualPolygonOptions.lineWidth
    }

    if(!id){
      id = makeid(5)
      this.annotationId = id
    }

    if(!pinBackgroundColor && pinColor)
      pinBackgroundColor = pinColor


    this.newAnnotationForm = this.fb.group({
      dynamic: [{value: dynamic ? dynamic : true, disabled : false}],
      source: [{value: source ? source : 'payload', disabled: false}],
      properties:[{value: properties ? properties : {}, disabled: false}],
      id:[{value: id ? id : makeid(5), disabled: false}]
    })

    this.propertiesForm = this.fb.group({
      name:[{value: name ? name : undefined, disabled :  this.data.translate ? checkIfFieldDisabled('annotations.name', fields, this.data.translateOriginal ) : false}],
      lat:[ {value: lat ? lat : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lat', fields, this.data.translateOriginal ) : false}, Validators.required],
      lng:[ {value: lng ? lng : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.lng', fields, this.data.translateOriginal ) : false}, Validators.required],
      directions:[ {value: directions ? directions : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.directions', fields, this.data.translateOriginal ) : false}],
      badge:[ {value: badge ? badge : this.data?.index , disabled : this.data.translate ? checkIfFieldDisabled('annotations.badge', fields, this.data.translateOriginal ) : false}],
      coordinate: [ {value: coordinate ? coordinate : [], disabled : this.data.translate ? checkIfFieldDisabled('annotations.coordinate', fields, this.data.translateOriginal ) : false}],
      id:[ {value: id ? id : this.data?.id , disabled : this.data.translate ? checkIfFieldDisabled('annotations.id', fields, this.data.translateOriginal ) : false}],
      subtitle: [{value: subtitle ? subtitle : undefined , disabled : this.data.translate ? checkIfFieldDisabled('annotations.subtitle', fields, this.data.translateOriginal ) : false}],
      title:[ {value: title ? title : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.title', fields, this.data.translateOriginal ) : false}],
      linkURL:[ {value: linkURL ? linkURL : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.linkURL', fields, this.data.translateOriginal ) : false} ,Validators.pattern(this.urlRegex)],

      encodedContent:  [{value: encodedContent ? encodedContent : undefined, disabled : this.data.translate ? checkIfFieldDisabled('annotations.encodedContent', fields, this.data.translateOriginal ) : false}],
        type: [{value: type ? type : "point", disabled : false}] , //  this.data.translate ? checkIfFieldDisabled('annotations.type', fields, this.data.translateOriginal ) : false
        pinBackgroundColor: [ {value: pinBackgroundColor ? pinBackgroundColor : '#FF5E38', disabled : this.data.translate ? checkIfFieldDisabled('annotations.pinBackgroundColor', fields, this.data.translateOriginal ) : false}, validColorValidator()],
        pinForegroundColor: [ {value: pinForegroundColor ? pinForegroundColor : '#000000', disabled : this.data.translate ? checkIfFieldDisabled('annotations.pinForegroundColor', fields, this.data.translateOriginal ) : false}, validColorValidator()]
    })

    this.setFieldVaildator('linkURL', linkURL)
    this.propertiesForm.valueChanges.subscribe( (value:any) => {
      this.checkInvalidColors()
    })

    this.propertiesForm.get('linkURL')?.valueChanges.subscribe(value => {
      this.setFieldVaildator('linkURL', value)
    })
  }

  setFieldVaildator(field, value) {
    if (!value) return;

    if (value.match(/\${(.+)\}/)){
      this.propertiesForm.get(field)?.setValidators([ Validators.pattern(this.urlRegexDynamic)]);
    } else {
      this.checkPattern_url(field)
    }
    this.propertiesForm.get(field)?.updateValueAndValidity({ emitEvent: false });
  }

  checkPattern_url(field){
    const fiedlValue:any = this.newAnnotationForm.get(field)
    if(fiedlValue){
      try {
        const imgUrl = new URL(fiedlValue)

        if(imgUrl.protocol === "pass:" )
          this.newAnnotationForm.get(field)?.setValidators([Validators.pattern(this.urlRegexDoc), urlInvalidCharactersValidator()]);

        if(imgUrl.protocol === "tridy:" || imgUrl.protocol === "context:" || imgUrl.protocol === "https:" || imgUrl.protocol === "http:" )
          this.newAnnotationForm.get(field)?.setValidators([Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]);

        this.newAnnotationForm.updateValueAndValidity()
      } catch(e){}
    }
  }

  onSaveEdit(){
    const propertiesValue = deepCopy( this.propertiesForm.value )
    const { pinBackgroundColor, pinForegroundColor, ...properties } = propertiesValue
    this.newAnnotationForm.patchValue({properties: properties})
    const data = { ...this.newAnnotationForm.value, pinBackgroundColor, pinForegroundColor }
    this.dialogRef.close([true, data])
  }


  checkInvalidColors(){
    if(this.propertiesForm.controls['pinBackgroundColor'].hasError('invalidColor'))
      this.invalid_pinBackgroundColor = true
    else
      this.invalid_pinBackgroundColor = false

    if(this.propertiesForm.controls['pinForegroundColor'].hasError('invalidColor'))
      this.invalid_pinForegroundColor = true
    else
      this.invalid_pinForegroundColor = false

  }

  initializePaletteColors(){
    var colors=[]
    const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
    const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
    const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
    const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
    colors.push(warmOrange)
    colors.push(darkblue)
    colors.push(pureWhite)
    colors.push(neutral)
    this.colorPalette=colors
  }
}
